<template>
  <div class="shipping">
    <v-row>
      <!-- address  -->
      <v-col cols="12" sm="12">
        <div class="address-width">
          <v-row>
            <v-col cols="12" sm="6">
              <h2 class="main-color">{{ $t("deliveryAddress") }}</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-form
                ref="form"
                id="address_form"
                class="address-form"
                v-model="validate"
              >
                <v-radio-group v-model="shippingObj.address_id">
                  <v-radio
                    @click="sendCityId(address.city_id, shippingObj.address_id)"
                    v-for="(address, index) in addresses"
                    :key="index"
                    :value="address.id"
                    class="radio-position"

                  >
                    <template v-slot:label>
                      <div class="address-width">
                        <div class="address-row">
                          <div class="address-img">
                            <v-img
                              src="../../assets/images/loc.png"
                              width="100px"
                            ></v-img>
                          </div>
                          <div class="address-width">
                            <v-row class="address-row-style">
                              <v-col cols="12" md="6">
                                {{ $t("CountryOfResidence") }}
                                <span class="address-span">
                                  {{ address.country }}</span
                                >
                              </v-col>
                              <v-col cols="12" md="6">
                                {{ $t("Erea") }}
                                <span class="address-span">{{
                                  address.city
                                }}</span>
                              </v-col>
                              <!--       <v-col cols="12" md="4">
                             {{ $t("City") }} : {{ address.address }} 
                          </v-col> -->
                            </v-row>
                            <v-row class="address-row-style">
                              <v-col cols="12">
                                {{ $t("Address") }}
                                <span class="address-span">{{
                                  address.address
                                }}</span>
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                      </div>
                    </template>
                  </v-radio>

                  <div
                    class="another-address-row"
                    @click="
                      newShipment = true;
                    "
                  >
                    <div>
                      <div class="image-loc">
                        <v-img
                          src="../../assets/images/greenLocation.png"
                        ></v-img>
                      </div>
                      <div class="radio-another-address">
                        {{ $t("anotherAddress") }}
                      </div>
                      <!-- <v-radio :label="$t('anotherAddress')" ></v-radio> -->
                    </div>
                  </div>
                </v-radio-group>

                <div class="address" v-if="newShipment">
                  <div class="item">
                    <label for="country" class="main-color"
                      >{{ $t("Country") }}
                    </label>
                    <v-select
                      solo
                      :items="countries"
                      item-text="name"
                      item-value="id"
                      @change="getCities"
                      v-model="selectedCountry"
                      :rules="[validationRules.required]"
                      color="#13a8b1"
                    ></v-select>
                  </div>
                  <div class="item">
                    <label for="city" class="main-color"
                      >{{ $t("City") }}
                    </label>
                    <v-autocomplete
                      v-model="shippingObj.user_address.user_city_id"
                      item-text="name"
                      item-value="id"
                      solo
                      :items="cities"
                      :rules="[validationRules.required]"
                    ></v-autocomplete>
                  </div>
                  <div class="item">
                    <label for="country" class="main-color"
                      >{{ $t("addressInDetails") }}
                    </label>
                    <v-textarea
                      v-model="shippingObj.user_address.address"
                      solo
                      :rules="[
                        validationRules.required,
                        validationRules.spaces,
                      ]"
                    ></v-textarea>

                    <v-btn class="btn-style " @click="addNewAddress()">
                      {{ $t("addNewAddress") }}
                    </v-btn>
                  </div>
                </div>
              </v-form>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { validationMixin } from "../../mixins/validationMixin";

export default {
  name: "ShippingComponent",
  mixins: [validationMixin],

  props: {
    addresses: {
      type: Array,
      required: true,
    },
    countries: {
      type: Array,
      required: true,
    },
    cities: {
      type: Array,
      required: true,
    },
    defultAddressId: {
      type: Number
    },
    defultCityId: {
      type: Number
    },
    
   
  },
  data() {
    return {
      selectedCountry: "",
      newShipment: false,
      validate: false,
      cityId: "",
      shippingObj: {
        address_id: 0,
        user_address: {
          address: "",
          user_city_id: "",
        },
      },
    };
  },
  watch: {
    defultAddressId: function(newVal) {
      this.shippingObj.address_id = newVal;
    },
    defultCityId: function(newVal) {
      this.shippingObj.user_address.user_city_id = newVal;
      this.sendCityId(newVal, this.shippingObj.address_id)
    }
  },
  mounted(){
    //
  },
  created(){
    this.shippingObj.address_id = this.defultAddressId;
  },
  methods: {
    
    addNewAddress() {
      if (this.validate) {
        this.loading = true;
        this.$http
          .post(
            this.getApiUrl + "/market/addresses/create",
            this.shippingObj.user_address,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
                locale: localStorage.locale,
              },
            }
          )
          .then((response) => {
            this.loading = false;
            if (response.data.status.error == false) {
              //   this.$refs.snack.sendSuccessAlert(response.data.status.message);
              this.$emit("getAddresses");
              this.newShipment = false;
              this.resetFormFields();
            }
          });
      } else {
        this.$refs.form.validate();
      }
    },
    resetFormFields() {
      this.shippingObj.user_address = {
        address: "",
        user_city_id: "",
      };
      this.selectedCountry = "";
      this.$refs.form.resetValidation();
    },
    sendCityId(cityId, addressId) {
      this.newShipment = false;
      this.cityId = cityId;
      this.shippingObj.address_id = addressId;
      this.$emit("getCityId", cityId, addressId);
    },
    getCities() {
      this.$http
        .get(this.getApiUrl + "/market/cities/" + this.selectedCountry, {
          headers: {
            locale: localStorage.locale,
          },
        })
        .then((response) => {
          if (response.data.status.error == false) {
            this.cities = response.data.data;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.address-width {
  width: 100% !important;
}
.address-row {
  display: flex;
  text-align: right;
  background-color: #fbfbfb;
  padding: 1rem;
}

.address-row-style {
  padding: 0px 3rem;
}
.address-span {
  color: gray;
  font-weight: 300;
}
.address-img {
  width: 82px;
  border: 0.1px solid #f0f0f0;
  background-color: white;
  padding: 10px 13px;
}
.v-radio.radio-position.theme--light {
  display: flex;
  align-items: end;
}
.another-address-row {
  background-color: #f6f6f6;
  display: flex;
  justify-content: center;
  padding: 3rem;
  border: 2px dashed #13a8b147;
}

.image-loc {
  width: 50px !important;
  margin: auto;
}
.radio-another-address {
  font-size: 30px !important;
  color: rgb(31, 31, 31);
}
.shipping {
  padding: 2rem;
}
.btn-style {
  background-color: #10a8b1 !important;
  color: #fff;
  padding: 0px 35px;
  border-radius: 3px;
}
</style>